import map from '@/assets/images/world-map.webp';
import axiosInstance from "@/axios";
import { useEffect, useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from 'axios';
const RegisteredOffices = () => {
  const [offices, setOffices] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

 
  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/contact`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setOffices(events.Offices);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  // Handle form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/request/contactus", {
        name: form.name,
        email: form.email,
        description: form.message, // assuming backend expects 'description'
      });

      setSubmitted(true);
      toast.success("Message sent successfully!");
      setForm({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12 space-y-16">
      <div className="w-full flex flex-col md:flex-row gap-8">
        {/* Registered Offices */}
        <div className="w-full md:w-1/2 space-y-6">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
            Registered Offices
          </h2>

          {offices.map((office, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 shadow-md hover:shadow-xl transition-shadow duration-300 rounded-2xl p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-blue-100 p-3 rounded-full">
                  <FaMapMarkerAlt className="text-blue-600 text-xl" />
                </div>
                <h3 className="text-xl font-semibold text-gray-700">
                  {office.country}
                </h3>
              </div>

              <div className="pl-2">
                <p className="text-lg font-medium text-gray-800">
                  {office.company}
                </p>
                <p className="text-gray-600 mt-2">{office.address}</p>
                <p className="my-2 text-gray-800 font-semibold">
                  Call us at:{" "}
                  <span className="text-blue-600">{office.phone}</span>
                </p>
                {/* <a
                  href={office.directionsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-4 text-blue-600 font-medium hover:underline"
                >
                  <img src={map} alt="error" className="w-10 h-10"/> Get Directions
                </a> */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2849.9733144420893!2d76.99925997326876!3d11.074048753637076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8580e989194d7%3A0xcac54f6a95a70760!2sSmik%20Systems%20(OPC)%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1754538834039!5m2!1sen!2sin"
                  width="200"
                  height="180"
                  style={{ border: 0, marginLeft: "0px" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Contact Form */}
        <div className="w-full md:w-1/2 bg-white p-6 rounded-xl shadow-lg space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Get in Touch</h2>

          {submitted && (
            <div className="text-green-600 font-semibold">
              Message sent successfully!
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
              required
            />

            <textarea
              name="message"
              placeholder="Your Message"
              value={form.message}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-md h-32 focus:outline-none focus:ring-2 focus:ring-blue-300"
              required
            ></textarea>

            <button
              type="submit"
              className="bg-blue-600 text-white font-semibold px-6 py-2 rounded-md hover:bg-blue-700 transition"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisteredOffices;
